/* istanbul ignore file */
// TODO: ^ ignore coverage on this file until we can have app test scaffolding ready
import React from 'react'
import { CurriculumRouteContentGetter as RouteContentGetter } from 'layers/content/v3/Hocs/CurriculumRouteContentGetter'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContext'
import withApiError from 'layers/errorHandling/apiError'
import Pathways from './component'
import { resolveRouteServiceApp } from 'utils/routing/routeHelpers'

export const PathwayContainer = props => {
  const { match, navigationEvent, location, routeContent } = props || {}

  const { content = {}, loading, route } = routeContent || {}
  const pathwayContent =
    content.navigationPage || (route?.queryType && content[route.queryType])
  const normalizedContent = pathwayContent
    ? { ...content, navigationPage: pathwayContent }
    : content

  const readyToLoad = !!pathwayContent && !loading

  const handleTabChange = tab => {
    const { query } = location || {}
    const queryString = new URLSearchParams(query).toString()
    const destination = queryString ? `${tab.route}?${queryString}` : tab.route
    navigationEvent(destination)
  }

  return (
    readyToLoad && (
      <Pathways
        content={normalizedContent}
        handleTabChange={handleTabChange}
        match={match}
      />
    )
  )
}

const options = {
  app: ({ route }) => resolveRouteServiceApp(route),
  routeResolver: () => window?.location?.pathname,
}

export default withSiteContext(
  RouteContentGetter(withApiError(PathwayContainer), options),
)
